<template>
  <div
    v-tooltip.top="tooltip"
    class="ui-dropdown-search-list-item"
    :class="{ 'ui-dropdown-search-list-item--disabled': disabled }"
    @click="handleClick"
  >
    <div ref="labelRef" class="ui-dropdown-search-list-item__label">
      {{ item.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue'

import { DropdownListData } from './utils/types'
import { useResizeObserver } from '@vueuse/core'

type Props = {
  item: DropdownListData
  disabled?: boolean
}

type Emits = {
  'click:item': [data: DropdownListData['value'], event: Event]
}

const props = defineProps<Props>()

const emit = defineEmits<Emits>()

const labelRef = useTemplateRef('labelRef')

useResizeObserver(labelRef, () => {
  if (!labelRef.value) return
  isLabelEllipsis.value = labelRef.value.offsetWidth < labelRef.value.scrollWidth
})

const isLabelEllipsis = ref(false)

const tooltip = computed(() => {
  if (!isLabelEllipsis.value) return

  return {
    content: props.item.label,
    handleResize: true,
  }
})

const handleClick = (event: Event) => {
  if (props.disabled) return
  emit('click:item', props.item.value, event)
}
</script>

<style>
.ui-dropdown-search-list-item {
  @apply px-2.5 py-1.5;
  @apply rounded;
  @apply text-sm sm:text-xs;
  @apply text-[var(--text-color)];
  @apply hover:text-[var(--hover-color)];
  @apply hover:bg-[var(--hover-bg)];
  @apply cursor-pointer;

  &--disabled {
    @apply opacity-50;
    @apply cursor-not-allowed;
  }

  &__label {
    @apply truncate;
  }

  &--disabled {
    @apply opacity-50;
    @apply cursor-not-allowed;
  }
}
</style>
